import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTableCell = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        borderBottom: `var(--TableCell-borderWidth, 1px) solid ${
          isDark ? 'rgba(255, 255, 255, 0.06)' : 'var(--mui-palette-TableCell-border)'
        }`,
      };
    },
    paddingCheckbox: { padding: '0 0 0 24px' },
  },
} satisfies Components<Theme>['MuiTableCell'];
